import Vue from 'vue'
import App from './App.vue'
import '@/icons'
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
}).$mount('#app')

import Message from '@/components/message/index';
Vue.prototype.$message = Message;
const instance = Vue.prototype.$http = axios.create();
instance.interceptors.response.use(
    response => {
        const data = response.data
        if(data.code == 200){
            return Promise.resolve(data.msg);
        }else{
            return Promise.reject(data.msg);
        }
    },
    error => {
      if (error.response.status) {
        switch (error.response.status) {
          case 404:
            return Promise.reject("网络请求不存在")
            break;
        }
        return Promise.reject(error.response.data.message)
      }
    }
)